export default __webpack_public_path__ + "static/media/all-good-pending.9cee5eda.svg";